<div
    class="navbar-header"
    [ngClass]="fuseConfig.layout.navbar.secondaryBackground"
>
    <div class="logo" (click)="onLogoClick($event)">
        <img class="logo-icon" src="assets/logo/logoWFOIcon.svg" />
        <div>
            {{ logoText }}
        </div>
    </div>

    <button
        mat-icon-button
        class="toggle-sidebar-folded"
        (click)="toggleSidebarFolded()"
        fxHide.lt-lg
        matTooltip="{{ 'NAV.TOGGLE' | translate }}"
    >
        <mat-icon>menu</mat-icon>
    </button>

    <button
        mat-icon-button
        class="toggle-sidebar-opened"
        (click)="toggleSidebarOpened()"
        fxHide.gt-md
        matTooltip="{{ 'NAV.COLLAPSE' | translate }}"
    >
        <mat-icon>arrow_back</mat-icon>
    </button>
</div>

<div
    class="navbar-content"
    fusePerfectScrollbar
    [fusePerfectScrollbarOptions]="{ suppressScrollX: true }"
    [ngClass]="fuseConfig.layout.navbar.primaryBackground"
>
    <fuse-navigation layout="vertical"></fuse-navigation>
</div>
